import { useState, useCallback, useMemo } from "react";

/**
 * Упрощённый хук управления фильтрами и навигацией
 */
export const useHierarchicalFilters = () => {
    // Параметры отображения
    const [dateRange, setDateRange] = useState({
        start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
        end: new Date(),
    });
    const [limit, setLimit] = useState(10);
    const [viewMode, setViewMode] = useState("top");
    const [sortBy, setSortBy] = useState("delayCount");

    // Навигационные уровни
    const [level, setLevel] = useState("company");
    const [currentIds, setCurrentIds] = useState({
        departmentId: null,
        shiftId: null,
    });

    const handleFilterFieldChange = useCallback((field, value) => {
        if (field === "dateRange") setDateRange(value);
        if (field === "limit") setLimit(value);
        if (field === "viewMode") setViewMode(value);
        if (field === "sortBy") setSortBy(value);
    }, []);

    const goToDepartments = useCallback(() => {
        setLevel("department");
        setCurrentIds({ departmentId: null, shiftId: null });
    }, []);

    const goToShifts = useCallback((departmentId) => {
        setLevel("shift");
        setCurrentIds({ departmentId, shiftId: null });
    }, []);

    const goToEmployees = useCallback((departmentId, shiftId) => {
        setLevel("employee");
        setCurrentIds({ departmentId, shiftId });
    }, []);

    const resetToCompany = useCallback(() => {
        setLevel("company");
        setCurrentIds({ departmentId: null, shiftId: null });
    }, []);

    return {
        dateRange,
        limit,
        viewMode,
        sortBy,
        handleFilterFieldChange,
        goToDepartments,
        goToShifts,
        goToEmployees,
        resetToCompany,
        currentLevel: level,
        currentIds,
    };
};
